import { Component, OnInit } from '@angular/core';
import { RestService } from '../../service/rest.service';
import { LoaderService } from '../../service/loader.service';
import { Message } from '../../service/message.service';

@Component({
    selector: 'app-say',
    templateUrl: './say.component.html',
    styles: [],
    standalone: false
})
export class SayComponent implements OnInit {

constructor(private rest:RestService,private loader:LoaderService,private message:Message){}

feedback = {
  name:'',
  company:'',
  message:''
}

  ngOnInit(): void {}

  sendFeedback(){
    this.loader.on()
    this.rest.post('/user/feedback',this.feedback).subscribe({
      next: (value) => {
        this.loader.off(true)
        this.message.showMessage('Feedback inviato', 'success')
        this.feedback = {
  name:'',
  company:'',
  message:''
}
      },
      error: (value) => {
        this.loader.off(true)
        this.message.showMessage("Errore nell'invio feedback", 'error')
        this.feedback = {
  name:'',
  company:'',
  message:''
}
      },
    })
  }
}
